module.exports = __webpack_public_path__ + "img/t5-img4.ce8f8acb.png";